import { SearchCriterias } from './search-criterias';

export class SearchElementCriterias extends SearchCriterias {
   name: string;
   organizerId: number;
}
